import { fork } from 'redux-saga/effects';
import browserHistory from 'history/browser';
import { router } from '@onegini/redux-saga-router';

import analyticsService from '../../common/Services/AnalyticsService';

const rootRoute = '';

const routes = {
  *[`${rootRoute}/console/content/collections/list`]() {
    analyticsService.trackPage({
      type:             analyticsService.trackingTypes.ROUTE,
      route:            browserHistory.location.pathname,
      pageNameSegments: ['Content collections list'],
    });
  },
  *[`${rootRoute}/console/content/collections/:collectionId/:action?`]({ collectionId, action }) {
    analyticsService.trackPage({
      type:             analyticsService.trackingTypes.ROUTE,
      route:            browserHistory.location.pathname,
      pageNameSegments: ['Content collection', collectionId],
    });
  },
  *[`${rootRoute}/admin/campaign/show/:experienceId/:section/:subsection?`]({ experienceId, section, subsection }) {
    analyticsService.trackPage({
      type:             analyticsService.trackingTypes.ROUTE,
      route:            browserHistory.location.pathname,
      pageNameSegments: ['Experience workspace', section, subsection],
    });
  },
  *[`${rootRoute}/console/experiencelibrary/home`]() {
    analyticsService.trackPage({
      type:             analyticsService.trackingTypes.ROUTE,
      route:            browserHistory.location.pathname,
      pageNameSegments: ['App store', 'home page'],
    });
  },
  *[`${rootRoute}/console/experiencelibrary/category/:category`]({ category }) {
    analyticsService.trackPage({
      type:             analyticsService.trackingTypes.ROUTE,
      route:            browserHistory.location.pathname,
      pageNameSegments: ['App store', 'category', category],
    });
  },
  *[`${rootRoute}/console/experiencelibrary/app/:app`]({ app }) {
    analyticsService.trackPage({
      type:             analyticsService.trackingTypes.ROUTE,
      route:            browserHistory.location.pathname,
      pageNameSegments: ['App store', 'app', app],
    });
  },
  // removing this section for now as it tracks all pages in the console but doesn't track push loader
  // *[`${rootRoute}/*?`]() {
  //   analyticsService.trackPage({
  //     type:             analyticsService.trackingTypes.ROUTE,
  //     route:            browserHistory.location.pathname,
  //     pageNameSegments: browserHistory
  //       .getCurrentLocation()
  //       .pathname.split('/')
  //       .replace(/^\/+/, ''), // we don't want no leading slashes
  //   });
  // },
};

// for now this will ensure we bootstrap the app on each route
const options = {
  matchAll: false,
  *beforeRouteChange() {
    // you could just track all pages here...
    // analyticsService.trackPage({
    //   type:    analyticsService.trackingTypes.ROUTE,
    //   route:   browserHistory.getCurrentLocation(),
    //   message: 'tracking a route',
    // });
  },
};

export default function* analyticsSaga() {
  // register router saga
  yield fork(router, browserHistory, routes, options);
}
